import styles from './CalendarGrid.module.css'

interface CalendarGridProps {
  days: number[]
  hasEvent: (day: number) => boolean
  onClick: (day: number) => void
}

export function CalendarGrid({ days, hasEvent, onClick }: CalendarGridProps) {
  return (
    <div className={styles.calendarGrid}>
      {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((d, i) => (
        <div key={i} className={styles.dayHeader}>{d}</div>
      ))}
      {days.map((day, i) => {
        const has = hasEvent(day)
        return (
          <button
            key={i}
            className={`${styles.day} ${has ? styles.hasEvent : ''}`}
            onClick={() => day > 0 && onClick(day)}
          >
            <span className={styles.dayNum}>{day > 0 ? day : ''}</span>
            {has && <span className={styles.eventDot} />}
          </button>
        )
      })}
    </div>
  )
}
